import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import {LogicGroupType} from "../../../../../../../../models/jsonlogic/logic-group-type";

@Component({
  selector: "one-to-many-query",
  templateUrl: "./one-to-many-query.component.html",
})
export class OneToManyQueryComponent implements OnInit {

  @Input() public lines: any[] = [];
  @Input() public conditions: any;
  @Input() public isLtr: boolean = true;
  @Output() public close = new EventEmitter();
  @Output() public saveQuery = new EventEmitter();

  public groups: any[] = [];
  public copy: any[];
  public changeCopy: boolean = true;

  public ngOnInit(): void {
    this.initGroups();
  }

  public checkLines() {
    let isOk = true;
    this.groups.forEach((g) => {
      g.items.forEach((i) => {
        const lineExists = this.lines.find((l) => {
          return l.lineId === i.lineId;
        });
        // console.log(i.lineId, lineExists);
        if (!lineExists) {
          isOk = false;
        }
      });
    });
    return isOk;
  }

  public initGroups() {
    // console.log("--- checkLines", this.checkLines(), this.conditions);
    if (!this.conditions || !this.conditions.length) {
      this.groups = [{
        type: LogicGroupType.AND,
        items: this.initialLines(),
      }];
    } else {
      if (this.conditions instanceof Array || typeof this.conditions === "object") {
        this.groups = this.conditions;
      } else {
        this.groups = JSON.parse(this.conditions);
      }
      if (!this.checkLines()) {
        this.groups = [{
          type: LogicGroupType.AND,
          items: this.initialLines(),
        }];
      }
    }
    this.fireOnChangeEvent();
    this.copy = JSON.parse(JSON.stringify(this.groups));
  }

  public initialLines() {
    const tempLines = [];
    if (this.lines.length) {
      this.lines.forEach((l) => {
        tempLines.push({ type: LogicGroupType.AND, lineId: l.lineId });
      });
    }
    return tempLines;
  }

  public getLineItemName(lineId, position) {
    const line = this.lines.find((l) => l.lineId === lineId);
    if (position === "start") {
      return line?.field?.fieldName || line?.field?.label;
    } else {
      return line?.input?.name;
    }
  }

  public closeSettings() {
    this.close.emit();
  }

  // Drag & Drop
  public dropped(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.changeCopy = false;
      event.container.data.forEach((e, i) => {
        e.type = this.copy[i].type;
      });
      this.changeCopy = true;
    }
    this.fireOnChangeEvent();
  }

  public droppedItem(event: CdkDragDrop<any[]>, j) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.changeCopy = false;
      event.container.data.forEach((e, i) => {
        e.type = this.copy[j].items[i].type;
      });
      this.changeCopy = true;
    } else if (event.previousContainer.id.endsWith("-conditionsList")) {
      const item = event.previousContainer.data[event.previousIndex];
      if (item) {
        const copyItem = {type: item.type, lineId: item.lineId};
        event.container.data.splice(event.currentIndex, 0, copyItem);
      }
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
    for (const item of event.container.data) {
      for (const key of Object.keys(item)) {
        if (key === "type" || key === "lineId" ) {
          continue;
        }
        delete item[key];
      }
    }
    this.fireOnChangeEvent();
  }

  public createConnectedTo(index) {
    const connectedTo = [];
    this.groups.forEach((group, i) => {
        if (i === index) { return; }
        connectedTo.push("conditionsSelected-" + i);
    });
    return connectedTo;
  }

  private getLogicType(andOrType: string) {
    return andOrType === "AND" ? LogicGroupType.AND : LogicGroupType.OR;
  }

  public removeGroup(j) {
    const movingItems = this.groups[j].items;
    movingItems.forEach((i) => {
      this.groups[0].items.push(i);
    });
    this.groups.splice(j, 1);
    this.fireOnChangeEvent();
  }

  public addNewBlockAfter(group) {
    this.groups.splice(this.groups.indexOf(group) + 1, 0, { type: LogicGroupType.AND, items: [] });
    this.fireOnChangeEvent();
  }

  public conditionAndOrTypeChanged(andOrType: string, groupIndex, conditionIndex) {
    this.groups[groupIndex].items[conditionIndex].type = this.getLogicType(andOrType);
    if (this.changeCopy) {
      this.copy = JSON.parse(JSON.stringify(this.groups));
    }
    this.fireOnChangeEvent();
  }

  public groupAndOrTypeChanged(andOrType: string, groupIndex) {
    this.groups[groupIndex].type = this.getLogicType(andOrType);
    if (this.changeCopy) {
      this.copy = JSON.parse(JSON.stringify(this.groups));
    }
    this.fireOnChangeEvent();
  }

  public fireOnChangeEvent() {
    console.log("--- updated Groups", this.groups);
  }

  public saveSettings() {
    // this.saveQuery.emit({filters: JSON.stringify(this.groups)});
    this.saveQuery.emit({filters: this.groups});
  }

}
